export default __webpack_public_path__ + "static/media/hublot-watch-2022.f759c946.webp";